import { useEffect, useState } from 'react'

import type { AbleTimeModel, TicketDetailModel } from '@/components/purchase/components/parkinglot/model'

import paymentEvents from '@/utils/gaEvents/paymentEvents'

import type { TicketDailyAbleTimeResDto, TicketMonthlyAbleTimeResDto } from '@/api/client/purchase/dto/purchaseDto'
import Shared from '@/shared'

import { COUPON_TYPE_GROUP } from '@/enums/detail'

import { getTicketDailyAbleTime, getMonthlyTicketDailyAbleTime } from '@/api/client/purchase'

export interface PurchaseEnteringTimeViewModel {
  texts: object
  states: {
    enteringTime: AbleTimeModel
    time: AbleTimeModel[]
    selectedIndex: number
    isNoticeOpen: boolean
    haveEnteringTime: boolean
  }
  setters: object
  handlers: {
    handleEnteringTimeValue: (index: number) => void
    handleNoticeOpen: () => void
    onClickTimeNextBtn: () => void
    onClickHeaderBackBtn: () => void
  }
}

const usePurchaseEnteringTimeViewModel = (data: TicketDetailModel): PurchaseEnteringTimeViewModel => {
  const setStep = Shared.States.usePurchaseStep((state) => state.setPurchaseStep)
  const [enteringTime, setEnteringTime] = useState<AbleTimeModel>({
    title: '',
    predictBeginTime: '',
    predictEndTime: ''
  })
  const [time, setTime] = useState<AbleTimeModel[]>([])
  const [selectedIndex, setSelectedIndex] = useState<number>(0)
  const [isNoticeOpen, setIsNoticeOpen] = useState(false)
  const [haveEnteringTime, setHaveEnteringTime] = useState(false)

  useEffect(() => {
    handleAbleTimes()
  }, [])

  const handleAbleTimes = async () => {
    const ableTimes: TicketDailyAbleTimeResDto | TicketMonthlyAbleTimeResDto =
      data.couponTypeGroup !== COUPON_TYPE_GROUP.MONTHLY
        ? await getTicketDailyAbleTime({ seq: Number(data.couponSeq) })
        : await getMonthlyTicketDailyAbleTime({ seq: Number(data.couponSeq) })
    let times: AbleTimeModel[] = []
    if (data.couponTypeGroup !== COUPON_TYPE_GROUP.MONTHLY && 'times' in ableTimes.data) {
      times = ableTimes.data.times
    }
    setTime(times)
  }

  const handleEnteringTimeValue = (index: number) => {
    if (!time) return
    setHaveEnteringTime(true)
    setSelectedIndex(index)
    setEnteringTime(time[index])
  }

  const handleNoticeOpen = () => {
    setIsNoticeOpen((prev) => !prev)
  }

  const onClickTimeNextBtn = () => {
    paymentEvents.partner.onClickNextButton()
    setStep(2)
  }

  const onClickHeaderBackBtn = () => {
    setStep(0)
  }

  return {
    texts: {},
    states: {
      time,
      selectedIndex,
      enteringTime,
      isNoticeOpen,
      haveEnteringTime
    },
    setters: {},
    handlers: {
      handleEnteringTimeValue,
      handleNoticeOpen,
      onClickTimeNextBtn,
      onClickHeaderBackBtn
    }
  }
}

export default usePurchaseEnteringTimeViewModel
